export const TINCO_WEBSITE = 'https://tinco.app';

export const RECOVER_PASSWORD = 'https://www.tinco.app/recuperacao-de-senha';

export const SUPPORT = 'https://tinco.app/suporte';

export const TEMPLATE_SPREADSHEET_IMPORTING_EMPLOYEES = 'https://www.dropbox.com/scl/fi/ao1kfheehoihovhn0e8vn/Planilha-Modelo-Importa-o-de-Colaboradores.xlsx?rlkey=axxayu36i79x26z0b9sb9wa6g&e=1&dl=1';
